export default "__VITE_ASSET__dWMuCuZq__"